export const DOBOX_ACCENT_COLOR = 'var(--color-text-accent)';

export enum DoBoxTaskGroupSelectorVariant {
  MODAL = 'modal',
}
